import baseRouters from './base'
import workbenchRouters from './workbench'
import bigScreenRouters from './big-screen'
import deviceMy from './device-my'
import leaveSchool from './leave-school'
import pickChild from './pick-child'
import stranded from './stranded'
import notification from './notification'
import leave from './leave'

export default [
    ...baseRouters,
    ...bigScreenRouters,
    ...workbenchRouters,
    ...leaveSchool,
    ...deviceMy,
    ...stranded,
    ...notification,
    ...pickChild,
    ...leave
]
